import Spinner from "../components/Spinner";
import Landing from "./Landing";
import ErrorBox from "../components/Error/Box";
import AppHome from "./app/AppHome";
import TeamsSidebar from "@/components/Sidebars/Teams";
import Bottom from "./Bottom/Bottom";
import { useEffect, useRef, useState } from "react";
import StreamerModeAlert from "@/components/Error/Alerts/StreamerMode";
import VerifyEmailAlert from "@/components/Error/Alerts/VerifyEmail";
import { useQueryClient } from "@tanstack/react-query";
import OpenNotifications from "@/components/Error/Alerts/OpenNotifications";
import { useMediaQuery } from "@mui/material";
export default function Home({ socket }: { socket: any }) {

  const [count, setCount] = useState(1);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.location.pathname === "/chat") setCount(2);
  }, []);


  useEffect(() => {
    if (!ref.current) return;
    const hammer = new Hammer(ref.current);
    hammer.on("swiperight", () => {
      if (window.location.pathname === "/chat") return;
      if (count < 2) setCount((prevCount: any) => prevCount + 1);
    });
    hammer.on("swipeleft", () => {
      if (window.location.pathname === "/chat") return;
      if (count > 0) setCount((prevCount: any) => prevCount - 1);
    });
    return () => hammer.destroy();
  }, [ref.current, count]);

  const [streamerMode, setStreamerMode] = useState(() => {
    try {
      const storedMode = localStorage.getItem("streamerMode");
      if (!storedMode) {
        localStorage.setItem("streamerMode", JSON.stringify({
          enabled: false,
          shortcut: null,
          details: {
            hidePersonalInfo: true,
            hideInviteLinks: true,
            hideLastMessagesOnDMs: true,
          }
        }));
      }
      return storedMode ? JSON.parse(storedMode) : {
        enabled: false,
        shortcut: null,
        details: {
          hidePersonalInfo: true,
          hideInviteLinks: true,
          hideLastMessagesOnDMs: true,
        }
      };
    } catch (e) {
      console.error(e);
      return {}
    }
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const newValue = JSON.parse(localStorage.getItem("streamerMode") || "{}");
      setStreamerMode(newValue);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const queryClient = useQueryClient();
  const query = queryClient.getQueryState(["user"]) as any;
  
    const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <>
      {
        query.status != "success" ? (
          <Spinner />
        ) : query.isError ? (
          <>
            <ErrorBox message={query.error as unknown as string} />
          </>
        ) : !query.data?.user ? (
          <Landing />
        ) : (
          <>
            <div className="flex flex-col h-screen" ref={ref}>
              <StreamerModeAlert streamerMode={streamerMode} socket={socket} />
              <VerifyEmailAlert socket={socket} streamerMode={streamerMode} user={query.data?.user} />
              <OpenNotifications streamerMode={streamerMode} />
              <div className="flex overflow-hidden h-full select-">
                {isMobile && <TeamsSidebar socket={socket} isOpen={count} />}
                <div className="flex flex-1 h-full">
                  <AppHome socket={socket} isOpen={count} />
                </div>
              </div>
              {!isMobile && <TeamsSidebar socket={socket} isOpen={count} />}
              <Bottom setIsOpen={setCount} notIncludeUsers={true} />
            </div>
          </>
        )
      }
    </>
  );
}